const CompetitionService = {
    /**
     * Checks if a competitor exists and returns errors in tripAdvisorUrl if any
     * @param teamId
     * @param tripAdvisorUrl
     * @returns {Promise<any>}
     */
    checkCompetitorExists: async (teamId, tripAdvisorUrl) => {
        const response = await axios.get(`/api/competitors/${teamId}/checkCompetitor?tripAdvisorUrl=` + tripAdvisorUrl);
        return response.data;
    }
}

module.exports = CompetitionService